import { useDispatch } from 'react-redux'
import BlogFooter from '../../../components/blog/Footer'
import { gotoLogIn } from '../../../redux/actions/AuthActions'

import { AppContainer, Body, Button, ButtonLink, Container, Content, H2, Image, MobileHeading, Show, Text } from '../landing.styles.js'

import Brands from '../Brands'
import FooterBanner from '../FooterBanner'
import Header from '../Header'
import Join from '../Join'
import Reviews from '../Reviews'

import headerBg from './header-bg.png'
import img1 from './img1.png'
import img2 from './img2.png'
import img3 from './img3.png'
import img4 from './img4.png'
import img5 from './img5.png'

const Kitchen = () => {
  const dispatch = useDispatch()

  const openLogin = () => {
    dispatch(gotoLogIn())
  }
  return (
    <div>
      <Header
        title="Room Layout Planner App for Smart Furniture Arrangement"
        subtitle="Use our furniture layout app to plan your room, arrange furniture, and visualize your space — all in one virtual room planner."
        bg={headerBg}
        meta={{
          title: 'Room Layout Planner App | Virtual Furniture Arrangement Tool',
          description: 'Plan any room with our room layout planner app. Arrange furniture, test layouts, and redesign virtually with the best furniture layout and room arrangement app.'
        }}
        alt="Room layout planner app interface with virtual room layout and modern furniture arrangement"
      />
      <Join
        title="Join 10 Million+ Users on the Leading Room Layout Planner App"
        description="Design your space with confidence using the DecorMatters room layout planner app. Rearrange furniture, test layouts, and visualize designs in real time — all from your phone. Whether it's a bedroom, kitchen, office, or living room, our virtual room planner helps you create smart, stylish layouts with ease."
      />
      <Body>
        <Container>
          <Content>
            <Show on="desktop">
              <H2>A Furniture Layout App That Makes Interior Design Easy</H2>
            </Show>
            <Text>
              Redesigning a room is simple with the DecorMatters room layout planner app. Easily visualize different layouts, furniture arrangements, and interior styles without lifting a thing. Just open the app to test new furniture placement, swap
              decor items, and adjust room elements like lighting, rugs, and wall art — all virtually. Whether you're planning a new space or reworking your current one, our room arrangement app gives you full control to create the layout that works
              best for your space and lifestyle.
            </Text>
            <Button onClick={openLogin}>Start Designing Now</Button>
          </Content>
          <MobileHeading>
            <Show on="mobile">
              <H2>A Furniture Layout App That Makes Interior Design Easy</H2>
            </Show>
            <Image src={img1} alt="Mobile app screen showing virtual room planner and furniture layout tools in use" />
          </MobileHeading>
        </Container>
        <Container>
          <Content>
            <Show on="desktop">
              <H2>Shop Real Furniture Through Our Room Layout Planner App</H2>
            </Show>
            <Text>
              The DecorMatters room layout planner app connects your interior design ideas directly to real products. Browse thousands of furniture and decor pieces while designing your space. Once you find the perfect layout, you can shop those
              exact items straight from the app. Whether you're placing a sofa, a rug, or wall art, our furniture layout app ensures what you see is what you can buy. It's the easiest way to stay on budget, compare options, and turn your virtual room
              arrangement into a real space — fast.
            </Text>
            <Button onClick={openLogin}>Start Designing Now</Button>
          </Content>
          <MobileHeading>
            <Show on="mobile">
              <H2>Shop Real Furniture Through Our Room Layout Planner App</H2>
            </Show>
            <Image src={img2} />
          </MobileHeading>
        </Container>
        <Container>
          <Content>
            <Show on="desktop">
              <H2>A Room Layout Planner App That Inspires And Connects</H2>
            </Show>
            <Text>
              DecorMatters is more than just a room layout planner app — it's a creative hub for interior design inspiration and collaboration. With over 10 million users, you can share your room layouts, get real feedback, and join design challenges
              to spark new ideas. Whether you're redesigning a bedroom, living room, or workspace, our virtual room planner helps you stay inspired, refine your style, and connect with others who love furniture arrangement and space planning as much
              as you do.
            </Text>
            <Button onClick={openLogin}>Start Designing Now</Button>
          </Content>
          <MobileHeading>
            <Show on="mobile">
              <H2>A Room Layout Planner App That Inspires And Connects</H2>
            </Show>
            <Image src={img3} alt="Virtual room planner app displaying real furniture and decor items available for purchase" />
          </MobileHeading>
        </Container>
        <Container>
          <Content>
            <Show on="desktop">
              <H2>Upgrade Your Room Arrangement App Experience</H2>
            </Show>
            <Text>
              Get more out of your room arrangement app with a DecorMatters Membership. Unlock powerful features that make it easier to plan furniture layouts, fine-tune room arrangements, and bring your ideas to life with accuracy and style.
              <br />
              <br />
              With Premium, you can:
              <br />
              ● Upload real room photos for accurate furniture placement
              <br />
              ● Use the AR ruler to measure and preview furniture in your space
              <br />
              ● Erase backgrounds for clean, polished designs
              <br />
              ● Access exclusive tools that streamline your space planning process
              <br />
              <br />
              Design smarter, faster, and more confidently with upgraded tools built for serious room planners.
            </Text>
            <Button onClick={openLogin}>Start Designing Now</Button>
          </Content>
          <MobileHeading>
            <Show on="mobile">
              <H2>Upgrade Your Room Arrangement App Experience</H2>
            </Show>
            <Image src={img4} alt="Room arrangement app showcasing premium tools like AR furniture preview and layout editor" />
          </MobileHeading>
        </Container>
        <AppContainer>
          <Container>
            <Show on="mobile">
              <ButtonLink target="_blank" href="https://apps.apple.com/us/app/decor-matters-design-play/id1168709467">
                Start Designing Now
              </ButtonLink>
            </Show>
            <Image src={img5} alt="Room layout planner app interface with virtual room layout and modern furniture arrangement" />
            <Content>
              <H2>Start Planning Your Room Layout Today</H2>
              <Text>
                Download the DecorMatters app to plan your room layout, arrange furniture virtually, and bring your space to life. Whether you're refreshing a room or starting from scratch, our virtual design tools help you create a layout that fits
                your furniture, style, and lifestyle.
              </Text>
              <Show on="desktop">
                <ButtonLink target="_blank" href="https://apps.apple.com/us/app/decor-matters-design-play/id1168709467">
                  Start Designing Now
                </ButtonLink>
              </Show>
            </Content>
          </Container>
        </AppContainer>
      </Body>
      <Brands />
      <Reviews />
      <FooterBanner />
      <BlogFooter />
    </div>
  )
}

export default Kitchen
